const constants = {
    TYPES: {
        STANDARDS: "Standards",
        FORM_BASIC_CONTAINER: "FormBasicContainer",
        STANDARDS_SELECTION: "StandardsSelection"
    }
};

export { constants as ELEMENT_CONSTANTS };
